import { createSelector } from 'reselect';

const getAllPropsSelector = (state) => {
  return {
    users: state.users,
    loading: (state.ajaxCallsInProgress>0)
  };
};

export default getAllPropsSelector;


/** WEBPACK FOOTER **
 ** ./src/container/UserContainer/selectors.js
 **/